import { siteInfo, aboutData } from '@/mocks/homeData';

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              <span>数字视频平台大全</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-3">
              {siteInfo.name}
              <span className="block text-primary-600 mt-1">高清免费在线观看导航</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 font-heading mb-5">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {siteInfo.name}深度聚合91视频、97视频、51视频、久久视频等主流数字视频平台，
              提供一站式的在线观看入口导航。每日更新推荐内容，覆盖高清免费资源、新片速递、
              经典回顾等多元品类，是数字视频爱好者的首选导航站点。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8 flex-wrap">
              {aboutData.highlights.map((item) => (
                <div key={item.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-600">{item.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500">{item.label}</div>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <button
                onClick={() => scrollTo('index')}
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                探索专题合集
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollTo('features')}
                className="px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg border border-background-300/60 transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                了解平台优势
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20golden%20abstract%20sunflower%20inspired%20digital%20art%20with%20flowing%20geometric%20shapes%2C%20modern%20cinematic%20composition%2C%20soft%20amber%20gradients%20blending%20into%20cream%2C%20luxurious%20textured%20finish%2C%20elegant%20minimalist%20design%2C%20warm%20atmospheric%20lighting%2C%20professional%20editorial%20quality&width=960&height=720&seq=hero-main-01&orientation=landscape"
                alt="向日葵视频 - 数字视频平台导航主页视觉"
                className="w-full h-full object-cover rounded-2xl"
                title="向日葵视频数字视频平台大全"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <button
          onClick={() => scrollTo('about')}
          className="w-10 h-10 flex items-center justify-center text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer animate-bounce"
          aria-label="向下滚动"
        >
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}